export default __webpack_public_path__ + "static/media/arrow-down-dark.def9880a.svg";